var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading1 && !_vm.loading2)?_c('div',[_c('OrdersStatisticsTable',{attrs:{"stats":_vm.stats1}}),_c('div',{staticClass:"pagebreak"}),_c('OrdersStatisticsCitiesTable',{attrs:{"stats":_vm.stats2}})],1):_c('Loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }